import { injectGlobal } from 'styled-components';

// eslint-disable-next-line no-unused-expressions
injectGlobal`
  html, body, #root {
    margin: 0;
    width: 100%;
    height: 100%;
    font-family: 'Roboto Condensed';
  }
`;



// WEBPACK FOOTER //
// ./src/globalStyles.js